import { useNavigate } from "react-router-dom";

export default function useGoBack(alternativeRoute="/") {
  const navigate = useNavigate();

  function goBackHandler() {
    const canGoBack = window.history.state?.idx > 0;
    if (typeof window !== "undefined" && window.SuarteDebug?.artworkRouting) {
      console.log("[ARTWORK_ROUTING][go-back]", {
        at: new Date().toISOString(),
        canGoBack,
        historyIndex: window.history.state?.idx ?? null,
        alternativeRoute,
      });
    }
    if (canGoBack) {
      navigate(-1);
    } else { 
      navigate(alternativeRoute, { replace: true });
    }
  }

  return goBackHandler;
}
